import { useTranslation } from 'react-i18next';
import LabShelf from '../components/project/LabShelf/LabShelf';
import ProjectGrid from '../components/project/ProjectGrid/ProjectGrid';
import ProjectRows from '../components/project/ProjectRows/ProjectRows';
import PageHero from '../components/ui/PageHero/PageHero';
import Section from '../components/ui/Section/Section';
import { projectsOwnedAs } from '../data/projects';
import { usePageMeta } from '../hooks/usePageMeta';
import type { TitledText } from '../locales/types';
import styles from './Work.module.css';

const ownProducts = projectsOwnedAs('product');
const labProjects = projectsOwnedAs('lab');
const clientProjects = projectsOwnedAs('clientWork');

export default function Work() {
    const { t } = useTranslation();
    usePageMeta(t('meta.workTitle'), t('meta.workDescription'));
    const cmsFacts = t('work.cms.facts', { returnObjects: true }) as unknown as TitledText[];

    return (
        <>
            <PageHero title={t('work.title')} lead={t('work.lead')} />
            <Section theme="light" shape="sheet">
                <div className={`page-inner ${styles.groups}`}>
                    <section className={styles.group} aria-labelledby="work-products-title">
                        <h2 id="work-products-title" className={styles.groupTitle}>{t('work.groups.products')}</h2>
                        <ProjectGrid projects={ownProducts} meta="fact" />
                    </section>
                    <section className={styles.group} aria-labelledby="work-clients-title">
                        <h2 id="work-clients-title" className={styles.groupTitle}>{t('work.groups.clientWork')}</h2>
                        <ProjectRows projects={clientProjects} />
                    </section>
                    <LabShelf projects={labProjects} headingId="work-lab-title" />
                    <section id="cms" className={styles.tool} aria-labelledby="work-cms-title">
                        <div className={styles.toolText}>
                            <h2 id="work-cms-title" className={styles.groupTitle}>{t('work.cms.title')}</h2>
                            <p className={styles.toolLead}>{t('work.cms.lead')}</p>
                        </div>
                        <dl className={styles.toolFacts}>
                            {cmsFacts.map((fact) => (
                                <div key={fact.title} className={styles.toolFact}>
                                    <dt>{fact.title}</dt>
                                    <dd>{fact.body}</dd>
                                </div>
                            ))}
                        </dl>
                    </section>
                </div>
            </Section>
        </>
    );
}
